// extracted by mini-css-extract-plugin
export default {"marker":"marker_marker__0MD8t","popup":"marker_popup__kL45g"};